export class FacturacionElectronicaConsultarModel{

    constructor(public DPROCESSDATE:string, public hora:string, public VPROCESSNAME:string, public VPROCESSSTATUS:string, public VERRORMESSAGE:string, public VLEGALSTATUS:string, public VGOVERNMENTRESPONSECODE:string ){}

}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/FacturacionElectronicaConsultarLog/FacturacionElectronicaConsultarLogModel.ts